import 'bootstrap/dist/css/bootstrap.min.css';
import './nav.css';
import React, { useState, useEffect } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [activeSection, setActiveSection] = useState(null);
  const handleScroll = () => {
    const mainNav = document.getElementById('mainNav');

    if (mainNav) {
      const navHeight = mainNav.offsetHeight;
      const sections = document.querySelectorAll('section');
  
      sections.forEach((section) => {
        const top = section.offsetTop - navHeight;
        const height = section.clientHeight;

        if (window.scrollY >= top - navHeight - 200  && window.scrollY <= top + height) {
          setActiveSection(section.id);
        }
      });
    }
  };
  
  
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

    return (
    // <div className='header sticky-top align-items-center'>
    //   <nav className="header sticky-top" id="mainNav">
    //     <ul className='d-flex justify-content-around justify-items-center'>
    //       <li className={activeSection === 'about' ? 'active' : ''}>
    //         <a href="#about"><b>About Me</b></a>
    //       </li>
    //       <li className={activeSection === 'services' ? 'active' : ''}>
    //         <a href="#services"><b>Services</b></a>
    //       </li>
    //       <li className={activeSection === 'skills' ? 'active' : ''}>
    //         <a href="#skills"><b>Skills</b></a>
    //       </li>
    //       <li className={activeSection === 'projects' ? 'active' : ''}>
    //         <a href="#projects"><b>Projects</b></a>
    //       </li>
    //       <li className={activeSection === 'experience' ? 'active' : ''}>
    //         <a href="#experience"><b>Experience</b></a>
    //       </li>
    //       <li className={activeSection === 'footer' ? 'active' : ''}>
    //         <a href="#footer"><b>Contact</b></a>
    //       </li>
    //     </ul>
    //   </nav>
    // </div>

    <Navbar id='mainNav' color="light" light expand="md" fixed="top" className="align-items-center">
      <NavbarBrand href="/">My Portfolio</NavbarBrand>
      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="mr-auto" navbar>
          <NavItem active={activeSection === 'about'} className="nav-link">
            <NavLink className="nav-link" href="#about">About Me</NavLink>
          </NavItem>
          <NavItem active={activeSection === 'services'} className="nav-link">
            <NavLink className="nav-link" href="#services">Services</NavLink>
          </NavItem>
          <NavItem active={activeSection === 'skills'} className="nav-link">
            <NavLink className="nav-link" href="#skills">Skills</NavLink>
          </NavItem>
          <NavItem active={activeSection === 'projects'} className="nav-link">
            <NavLink className="nav-link" href="#projects">Projects</NavLink>
          </NavItem>
          <NavItem active={activeSection === 'experience'} className="nav-link">
            <NavLink className="nav-link" href="#experience">Experience</NavLink>
          </NavItem>
          <NavItem active={activeSection === 'footer'} className="nav-link">
            <NavLink className="nav-link" href="#footer">Contact</NavLink>
          </NavItem>
          
        </Nav>
      </Collapse>
    </Navbar>

    );
   }
   
   export default NavBar;